import {MarkerCursorLabelModel} from './labelModels/markerCursorLabelModel';
import {ModulationCursor} from './modulationCursor';

/*
	Класс модуляционного курсора для спектра
*/
export class SpectrumModulationCursor extends ModulationCursor {
  constructor(
    labelModel: MarkerCursorLabelModel | null = null,
    applyCallback: Function | null = null,
    color = '#00FF00FF',
  ) {
    super(labelModel, applyCallback, color);
  }
}
